var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDeco6(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 395,
    height: 394,
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    xmlSpace: "preserve",
    overflow: "hidden",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-225 -1610)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M227.5 1807C227.5 1699.58 314.804 1612.5 422.5 1612.5 530.195 1612.5 617.5 1699.58 617.5 1807 617.5 1914.42 530.195 2001.5 422.5 2001.5 314.804 2001.5 227.5 1914.42 227.5 1807Z",
    stroke: "#000000",
    strokeWidth: 4.58333,
    strokeMiterlimit: 8,
    fill: "#D5A7CB",
    fillRule: "evenodd"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDeco6);
export default __webpack_public_path__ + "static/media/deco6.ef631cc965513e55b4a8ca63c095ed93.svg";
export { ForwardRef as ReactComponent };